export { default as ShieldCheckSolidIcon } from './ShieldCheckSolidIcon';
